exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tamanho[data-v-bc9728de]{\n    width: 200px;\n}\n", ""]);

// exports
